import axiosInstance from "./axiosInstance";

export const getSettings = () => {
  return axiosInstance.get(`setting/atten-dance/find-setting`, {
    params: { site: process.env.REACT_APP_SITE_ID },
  });
};

export const updateSettings = (settingsData) => {
  return axiosInstance.put(`setting/atten-dance`, {
    ...settingsData,
    site: process.env.REACT_APP_SITE_ID,
  });
};

export const getRaceTopSetting = () => {
  return axiosInstance.get(`setting/race-top/find-setting`, {
    params: { site: process.env.REACT_APP_SITE_ID },
  });
};

export const updateRaceTopSetting = (config) => {
  return axiosInstance.put(`setting/race-top`, config);
};

export const getLotteryLuckySetting = () => {
  return axiosInstance.get(`setting/lottery/find-setting`, {
    params: { site: process.env.REACT_APP_SITE_ID },
  });
};

export const updateLotteryLuckySetting = (config) => {
  return axiosInstance.put(`setting/lottery`, config);
};
